import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { copyToClipboard } from "@redotech/arbiter/clipboard";
import { Flex } from "@redotech/arbiter/flex";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import CheckIcon from "@redotech/redo-icons/check.svg";
import CopyIcon from "@redotech/redo-icons/copy-01.svg";
import { toast } from "@redotech/redo-web/alert";
import { memo, useState } from "react";

/** A read-only value with a Copy button beside it. */
export const CopyField = memo(function CopyField({
  value,
  ariaLabel,
}: {
  value: string;
  ariaLabel: string;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <Flex align="flex-end" gap="md">
      <Flex grow={1}>
        <RedoTextInput
          ariaLabel={ariaLabel}
          autoCompleteDisabled
          fullWidth
          setValue={() => {}}
          state="readonly"
          value={value}
        />
      </Flex>
      <RedoButton
        hierarchy="secondary"
        IconLeading={copied ? CheckIcon : CopyIcon}
        onClick={async () => {
          try {
            await copyToClipboard(value);
            setCopied(true);
          } catch {
            // The browser can deny clipboard access; the field stays selectable.
            toast("Couldn't copy. Select the value and copy it yourself.", {
              variant: "error",
            });
          }
        }}
        size="sm"
        text={copied ? "Copied" : "Copy"}
      />
    </Flex>
  );
});
